// extracted by mini-css-extract-plugin
module.exports = {"textDesplegable":"collaboracio_textDesplegable__cUPss","contingutDesplegable":"collaboracio_contingutDesplegable__Qo2wA"};